export { default as CertifiedBadge } from './certified-badge.svg'
export { default as EnglishCertifiedBadge } from './certified-badge-en.svg'
export { default as Profile } from './profile.svg'
